const getDeliveryFee = (deliveryFee, subTotal) => {
  if (!deliveryFee || !deliveryFee.amount) {
    return 0;
  }
  if (deliveryFee.freeDeliveryMoreThanEnabled) {
    if (
      deliveryFee.freeDeliveryMoreThanAmount &&
      deliveryFee.amount < deliveryFee.freeDeliveryMoreThanAmount
    ) {
      if (
        parseInt(subTotal) >= parseInt(deliveryFee.freeDeliveryMoreThanAmount)
      ) {
        return 0;
      } else {
        return deliveryFee.amount;
      }
    } else {
      if (parseInt(subTotal) >= parseInt(deliveryFee.amount)) {
        return 0;
      } else {
        return deliveryFee.amount;
      }
    }
  } else {
    return deliveryFee.amount;
  }
};

export default getDeliveryFee;
